import {
	AuthSubmit,
	AuthSubmitContent,
	AuthSubmitSpinner,
} from '../../authModal.styles';
import AuthCheckIcon from './AuthCheckIcon';

const IconSpark = () => (
	<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
		<path d="M12 1.8 13.9 9.1 21.2 11 13.9 12.9 12 20.2 10.1 12.9 2.8 11 10.1 9.1 12 1.8Z" />
	</svg>
);

const AuthFormSubmitButton = ({
	mode,
	isAuthPending,
	isAuthSuccess,
	isSubmitDisabled,
	translations,
}) => {
	const isRegister = mode === 'register';

	const getSubmitContent = () => {
		if (isAuthSuccess) {
			return (
				<AuthSubmitContent>
					<AuthCheckIcon />
					{isRegister
						? translations.registerSuccessButton
						: translations.loginSuccessButton}
				</AuthSubmitContent>
			);
		}

		if (isAuthPending) {
			return (
				<AuthSubmitContent>
					<AuthSubmitSpinner />
					{isRegister ? translations.registering : translations.loggingIn}
				</AuthSubmitContent>
			);
		}

		return (
			<AuthSubmitContent>
				{isRegister
					? translations.registerButton || 'Register'
					: translations.loginButton || 'Log In'}
				<IconSpark />
			</AuthSubmitContent>
		);
	};

	return (
		<AuthSubmit type="submit" disabled={isSubmitDisabled} $success={isAuthSuccess}>
			{getSubmitContent()}
		</AuthSubmit>
	);
};

export default AuthFormSubmitButton;
